module.exports = __webpack_public_path__ + "static/media/Medicaid.d6b4ef86.svg";